import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { themeAssetUrl } from "../../utils/themeAssets";
import { useBlockInspect } from "../../hooks/useBlockInspect";
import "./playerRules.css";

function PlayerRules() {
  const navigate = useNavigate();
  const user = useSelector((state) => state.auth.user);
  const { status, data } = useSelector((state) => state.theme);
  useBlockInspect();

  useEffect(() => {
    if (!user) navigate("/");
  }, [user, navigate]);

  if (status === "loading" || !data) {
    return <p className="player-message">Loading...</p>;
  }

  const rules = Array.isArray(data.rules) ? data.rules : [];
  const buttonStyle = {
    background: data.submit_color || "#1b3f9b",
    color: data.buttonText_color || "#ffffff",
  };

  return (
    <div className="player-rules">
      <div className="player-rules-logo-wrap">
        <img src={themeAssetUrl(data, "logo")} className="player-rules-logo" alt="" />
      </div>
      <div className="player-rules-badge-wrap">
        <div className="player-rules-badge" style={buttonStyle}>
          Rules
        </div>
      </div>
      <ul className="player-rule-list">
        {rules.map((rule, index) => (
          <li key={`${index}-${rule}`} style={{ color: data.text_color || "#060606" }}>
            {rule}
          </li>
        ))}
      </ul>
      <Link to="/game" className="player-next" style={buttonStyle}>
        Next
      </Link>
    </div>
  );
}

export default PlayerRules;
